const MOCK_INTERVIEW_FLAG = "showMockInterviewPrompt";

export const markFreshLogin = () => {
  localStorage.setItem(MOCK_INTERVIEW_FLAG, "true");
};

export const consumeFreshLoginFlag = (): boolean => {
  const value = localStorage.getItem(MOCK_INTERVIEW_FLAG);
  if (value === "true") {
    localStorage.removeItem(MOCK_INTERVIEW_FLAG);
    return true;
  }
  return false;
};

export const clearFreshLoginFlag = () => {
  localStorage.removeItem(MOCK_INTERVIEW_FLAG);
};
